/******************************************************************
 * process mustache template and load data
 *****************************************************************/
var Mustache = require('mustache');

window.MvpFE = window.MvpFE || {};
window.MvpFE.rebindFunctions = {};
window.MvpFE.rebindEvents = function () {
    for (var funcName in window.MvpFE.rebindFunctions) {
        window.MvpFE.rebindFunctions[funcName]();
    }
};

//bind HowISpend categories mustache template
function loadHowISpendCategories(Categories) {
    var Categoriesdata = { "HowISpendCategories": Categories.HowISpendCategories }; // Categories
    var template = $("#template_howISpend_Categories").html();
    if (template) {
        var content = Mustache.render(template, Categoriesdata);
        $(".how-i-spend-category-list").html(content)
    }
}
//bind HowISpend category Transactions mustache template
function loadHowISpendCategoryTransactions(Transactions) {
    var Transactionsdata = { "CategoryTransactions": Transactions.CategoryTransactions }; // Transactions
    var template = $("#template_howISpend_CategoryTransactions").html();
    if (template) {
        var content = Mustache.render(template, Transactionsdata);
        $(".how-i-spend-category-transactions-list").html(content)
    }
}

//HowISpend Binding mustache  template
if (!window.MvpFE.howISpend) {
    window.MvpFE.howISpend = {};
}

let Categories = window.MvpFE.howISpendCategories;//json data 
window.MvpFE.howISpend.loadHowISpendCategories = loadHowISpendCategories;
window.MvpFE.howISpend.loadHowISpendCategoryTransactions = loadHowISpendCategoryTransactions;
if (Categories) {
    $(function () {
        loadHowISpendCategories(Categories)
        loadHowISpendCategoryTransactions(Categories)
    });
}
//
module.exports = (function () {
    var TmplData = {};
    Mustache.tags = ['{[', ']}'];

    // get mustache template and set data to target element
    TmplData.setTemplateData = function (tmplId, data, target) {
        if (!data || $.isEmptyObject(data)) {
            return;
        }

        var template = $('#' + tmplId).html();
        if (!template) {
            return;
        }

        Mustache.parse(template);
        var rendered = Mustache.render(template, data);
        $(target).html(rendered);
    };

    function sortDataByProp(data, prop) {
        if (!data || $.isEmptyObject(data)) {
            return;
        }

        data = data.sort(function (a, b) {
            if (!a[prop]) a[prop] = '';
            if (!b[prop]) b[prop] = '';

            return (a[prop].toLowerCase() > b[prop].toLowerCase()) ? 1 : ((a[prop].toLowerCase() < b[prop].toLowerCase()) ? -1 : 0);
        });
    }

    function convertDataToGroupByLetter(data, rootProp, sortPropName) {
        if (!data || $.isEmptyObject(data)) {
            return;
        }

        var newData = {
            groups: []
        };

        var firstLetter;
        var group = {
            items: []
        };

        for (var i = 0; i < data[rootProp].length; i++) {
            if (!data[rootProp][i] || $.isEmptyObject(data[rootProp][i])) {
                continue;
            }

            var firstLetterNew = data[rootProp][i][sortPropName].charAt(0).toUpperCase();
            var item = jQuery.extend(true, {}, data[rootProp][i]);

            if (firstLetter !== firstLetterNew) {
                firstLetter = firstLetterNew;
                group = new Object({
                    items: []
                });
                group.firstLetter = firstLetterNew;
                newData.groups.push(group);
            }
            group.items.push(item);
        }

        return newData;
    }

    function createTmplDataFunc (dataVar, sortProp, rootName, tmplId, selector) {
        return function () {
            if (!window[dataVar]) {
                return;
            }

            TmplData[dataVar] = jQuery.extend(true, {}, window[dataVar]);
            TmplData[dataVar + 'Formated'] = {};
            sortDataByProp(TmplData[dataVar][rootName], sortProp);
            TmplData[dataVar + 'Formated'] = convertDataToGroupByLetter(TmplData[dataVar], rootName, sortProp);
            TmplData.setTemplateData(tmplId, TmplData[dataVar + 'Formated'], selector);
        }
    }

    //process data
    $(function () {
        window.MvpFE.loadTransToData();
        window.MvpFE.loadBpayBillers();
        window.MvpFE.loadBpayBillersSearchResult();
        window.MvpFE.loadChequeToPayees();
        window.MvpFE.loadExternalPayees();
        window.MvpFE.loadInstitutionPayee();
        window.MvpFE.loadInternationalTransferRecipient();
        window.MvpFE.loadInternationalSearchBank();
        window.MvpFE.loadExternalTransfer();
    });

    //Load transfer to account list data from global variable
    window.MvpFE.loadTransToData = function () {
        if (!window.dataMyAccount && !window.dataPayees && !window.dataBillers) {
            return;
        }

        //Transfer Money Data
        TmplData.dataMyAccount = jQuery.extend(true, {}, window.dataMyAccount);
        TmplData.dataPayeesSearch = jQuery.extend(true, {}, window.dataPayees); // for search result template
        TmplData.dataPayeesFormated = {}; // for init payees list template
        TmplData.setTemplateData('template_payees_myaccount', TmplData.dataMyAccount, '.payees-myaccount');
        sortDataByProp(TmplData.dataPayeesSearch.payees, 'nickname');
        TmplData.dataPayeesFormated = convertDataToGroupByLetter(TmplData.dataPayeesSearch, 'payees', 'nickname');
        TmplData.setTemplateData('template_payees_external_account', TmplData.dataPayeesFormated, '.payees-external-accounts');
    };

    //BPAY - billers
    window.MvpFE.loadBpayBillers = createTmplDataFunc('dataBillers', 'nickname', 'billers', 'template_billers', '.bpay-biller-list');

    //BPAY - billers search result
    window.MvpFE.loadBpayBillersSearchResult = createTmplDataFunc('dataNewBillers', 'name', 'billers', 'template_new_billers', '.bpay-new-billers-list');

    //Term Deposit Maintenance - Cheque tab payees
    window.MvpFE.loadChequeToPayees = createTmplDataFunc('dataChequeToPayees', 'nickname', 'payees', 'template_term_deposit_cheque_to_payee', '.term-deposit-cheque-to-payee-list');
    
    //External Payee - this could be used many places, like Credit External tab, address book
    window.MvpFE.loadExternalPayees = createTmplDataFunc('dataExternalPayees', 'nickname', 'payees', 'template_common_external_payee', '.common-external-payee-list');

    //Institution Payee
    window.MvpFE.loadInstitutionPayee = createTmplDataFunc('dataInstitutionPayee', 'name', 'payees', 'template_institution_payee', '.institution-payee-list');

    //International Transfer Recipients Payee
    window.MvpFE.loadInternationalTransferRecipient = createTmplDataFunc('dataInternationalRecipients', 'nickname', 'internationalRecipients', 'template_international_recipients', '.international-transfer-recipient');
   
    // International Transfer Search IBAN/Account Bank
    window.MvpFE.loadInternationalSearchBank= createTmplDataFunc('dataInternationalSearchBank', 'bankname', 'internationalSearchBank', 'template_iban_select_bank', '.international-transfer-search-bank-list');
 
    //Transfer External Account - payees
    window.MvpFE.loadExternalTransfer = createTmplDataFunc('dataExternalTransfer', 'nickname', 'payees', 'template_external_transfer', '.external-transfer-list');

    return TmplData;
})();